import React,{Component} from 'react';
import connect from "react-redux/es/connect/connect";
import * as bActs from '../../actions/billing-actions'
import * as wActs from '../../actions/website-actions'
import Select from "react-select";

//const FormUrl = "https://secure-staging.curopayments.net/gateway/";
const FormUrl = "https://secure.curopayments.net/gateway/";

class LoadBillerCuro extends Component {

  constructor(props) {
    super(props);
    this.state = {
      step: "SHOWBILLERS",
    };
  }

  getTranslation(key)
  {
    return this.props.WebPage.Translations[key];
  }

  handleBillerClick(e,type) {
    e.preventDefault();
    if(type=="ideal") { //For Ideal They Need To Select A Bank
      this.setState({step: "SHOWBANKS"});
      return;
    }
    let tran = this.props.Transaction;
    this.props.dispatch(bActs.CuroCreateOrder(
      tran.packageId,
      tran.Country,
      tran.HomeCountry,
      tran.UserId,
      tran.StartDate,
      tran.Guid,
      tran.CulturePath,
      tran.CurrencyCode,
      type,
      tran.RecordId,
      tran.Url
    ));
    this.setState({step: "LOADBILLER"});
  }


  render() {
    let banks = this.props.Billing.IdealBanks.map((v,i)=>{
      return {value: v.id, label: v.name};
    });


    let {CuroPaymentTypes} = this.props.Billing;
    let order = {}
    if(this.props.CreateOrder.Loaded && this.state.step === "LOADBILLER") {
      order = this.props.CreateOrder.Result.Result;
      setTimeout(() => {
        this.billingForm.submit();
      },2000);
    }


    return (
      <React.Fragment>

        {this.state.step === "SHOWBILLERS" &&
          <div>
            <h1 style={{textAlign: "center", marginTop: "0px"}}>Choose a billing type</h1>
            {CuroPaymentTypes.map((v,i) => {
              let availInCC = false;
              if(v.Active) {
                if(v.Countries.length == 0) {
                  availInCC = true;
                } else {
                  let cc = this.props.WebPage.Request.CountryCode;
                  if(v.Countries.filter((t)=>{
                    return t == cc;
                  }).length>0) {
                    availInCC = true;
                  }
                }
              }
              if(!availInCC) { return null; }
              return (
                <div onClick={(e) => {
                  this.handleBillerClick(e,v.Code);
                }} key={"biller-" + i} className="cell x4" style={{minHeight: "120px", display: "flex", alignContent: "center", justifyContent: "center", cursor: "pointer"}}>
                  <a href={"#"} onClick={(e) => {
                    this.handleBillerClick(e,v.Code);
                  }}>
                    <img src={v.Logo} alt={v.Name} style={{maxHeight: "75px", maxWidth: "150px"}}/><br/>
                    <div style={{paddingTop: "10px", textAlign: "center"}}>{v.Name}</div>
                  </a>
                </div>
              );
            })};
          </div>
        }
        {(!this.props.CreateOrder.Loaded && this.state.step === "LOADBILLER") &&
        <React.Fragment>
          <div className="large-text">{this.getTranslation("dash.pleasewait")}</div>
          <p style={{width: "100%", display: "flex", alignContent: "center", justifyContent: "center"}}>
            <img src="/imgs/loader.gif" width={"100px"} height={"100px"} alt={"Loading"}/>
          </p>
        </React.Fragment>
        }

        {this.state.step === "SHOWBANKS" &&
        <div style={{width: "500px", margin: "auto"}}>
          <p>Please choose a bank for your Ideal &copy; transaction</p>
          <Select options={banks} onChange={(sel) => {
            if(!wActs.isNullOrUndefined(sel)) {
              this.setState({bank: sel.value});
              let tran = this.props.Transaction;
              this.props.dispatch(bActs.CuroCreateOrder(
                tran.packageId,
                tran.Country,
                tran.HomeCountry,
                tran.UserId,
                tran.StartDate,
                tran.Guid,
                tran.CulturePath,
                tran.CurrencyCode,
                "ideal",
                tran.RecordId,
                tran.Url
              ));
              this.setState({step: "LOADBILLER"});
            }
          }
          }/>
          <div style={{marginBottom: "400px"}}></div>
        </div>
        }

        {(this.props.CreateOrder.Loaded && this.state.step === "LOADBILLER") &&
        <div>
          <div className="large-text">{this.getTranslation("dash.pleasewait")}</div>
          <p style={{width: "100%", display: "flex", alignContent: "center", justifyContent: "center"}}>
            <img src="/imgs/loader.gif" width={"100px"} height={"100px"} alt={"Loading"}/>
          </p>
          {this.props.CreateOrder.Loaded && this.props.CreateOrder.Result.Code === 200 &&
          <form ref = {(ref) => this.billingForm = ref} action={FormUrl} method="POST">
            <input type={"hidden"} name={"site_id"} id={"site_id"} value={order.site_id}/>
            <input type={"hidden"} name={"pt"} id={"pt"} value={order.pt}/>
            <input type={"hidden"} name={"currency_code"} id={"currency_code"} value={order.currency_code}/>
            <input type={"hidden"} name={"amount"} id={"amount"} value={order.amount}/>
            <input type={"hidden"} name={"description"} id={"description"} value={order.description}/>
            <input type={"hidden"} name={"reference"} id={"reference"} value={order.reference}/>
            <input type={"hidden"} name={"language_id"} id={"language_id"} value={order.language_id}/>
            <input type={"hidden"} name={"url_success"} id={"url_success"} value={order.url_success}/>
            <input type={"hidden"} name={"url_failure"} id={"url_failure"} value={order.url_failure}/>
            <input type={"hidden"} name={"url_pending"} id={"url_pending"} value={order.url_pending}/>
            <input type={"hidden"} name={"hash"} id={"hash"} value={order.hash}/>
          </form>
          }
        </div>
        }


        <div className="sep m-t-l"></div>
        <div className="clear"></div>


        <div className="full">
          <input type="submit" value={this.getTranslation("page.profile.previous")} onClick={(e) => { e.preventDefault(); this.props.handleBackToBilling(e)}}/>
        </div>

         <div className="secure-div">
          <img src="/imgs/billing/secure-site.png" alt="" style={{margin: "50px auto"}}/>
        </div>


      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    CreateOrder: state.Billing.CreateOrder,
    Billing: state.Billing.BillingData
  };
}

export default connect(mapStateToProps)(LoadBillerCuro);

